import script from "./FormulasTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasTabs.vue?vue&type=script&setup=true&lang=js"

import "./FormulasTabs.vue?vue&type=style&index=0&id=b850eca6&lang=scss"

const __exports__ = script;

export default __exports__